import { useMutation, useQueryClient } from '@tanstack/react-query';

import { redispatchOrder } from '../../../common/api/clients/order.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useOrderRedispatch = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: redispatchOrder,
        onSuccess: (redispatchedOrder) => {
            return queryClient.invalidateQueries({ queryKey: queries.orders.detail(redispatchedOrder.id).queryKey });
        },
    });
};
